"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptFlowSparkles = void 0;
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./AcceptFlowSparkles.css"));
var AcceptFlowSparkles = function () {
    return (react_1.default.createElement("div", { className: styles.container, "aria-hidden": "true" },
        react_1.default.createElement("div", { className: styles.iconBackground, "aria-hidden": "true" }),
        react_1.default.createElement(AcceptParticle, { x: -28, y: 24, delay: 0, size: 5 }),
        react_1.default.createElement(AcceptParticle, { x: -4, y: 0, delay: 0, size: 1.8 }),
        react_1.default.createElement(AcceptParticle, { x: 50, y: -26, delay: 0, size: 2.8 }),
        react_1.default.createElement(AcceptParticle, { sparkle: true, x: -30, y: -16, opacity: 0.6, size: 26, delay: 0.2 }),
        react_1.default.createElement(AcceptParticle, { sparkle: true, x: 70, y: -30, opacity: 1, size: 41, delay: 0.8 }),
        react_1.default.createElement(AcceptParticle, { sparkle: true, x: 86, y: 10, opacity: 0.2, size: 30, delay: 0.6 }),
        react_1.default.createElement(AcceptParticle, { sparkle: true, x: -40, y: -20, opacity: 0.8, size: 38, delay: 2 }),
        react_1.default.createElement(AcceptParticle, { sparkle: true, x: 80, y: 10, opacity: 1, size: 22, delay: 2.5 }),
        react_1.default.createElement(AcceptParticle, { sparkle: true, x: 24, y: -30, opacity: 0.6, size: 26, delay: 1.5 }),
        react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Large, className: styles.icon, "aria-hidden": "true" })));
};
exports.AcceptFlowSparkles = AcceptFlowSparkles;
var AcceptParticle = function (_a) {
    var x = _a.x, y = _a.y, opacity = _a.opacity, size = _a.size, delay = _a.delay, sparkle = _a.sparkle;
    if (sparkle) {
        return (react_1.default.createElement("svg", { "aria-hidden": "true", className: styles.sparkle, width: size, height: size, fill: "none", viewBox: "0 0 41 41", style: { left: x, top: y, animationDelay: "".concat(delay, "s") } },
            react_1.default.createElement("path", { fill: "#1D7E8A", fillOpacity: opacity, d: "M20.5 0s1.098 10.581 5.508 14.992C30.418 19.402 41 20.5 41 20.5s-10.581 1.098-14.992 5.508C21.598 30.418 20.5 41 20.5 41s-1.098-10.581-5.508-14.992C10.582 21.598 0 20.5 0 20.5s10.581-1.098 14.992-5.508C19.402 10.582 20.5 0 20.5 0z" })));
    }
    return (react_1.default.createElement("div", { "aria-hidden": "true", className: styles.particle, style: { left: x, top: y, animationDelay: "".concat(delay, "s"), width: size, height: size } }));
};
